import React from 'react'
import ReactDOM from 'react-dom'

import { BrowserOptions } from '@sentry/react'

import LoadStyles from '@driftt/tide-core/dist/styles'
import ConnectedApp from '@driftt/traffic-control'

import config from 'config'

import App from './layouts/App'

import './index.css'

LoadStyles()

const sentryConfig: BrowserOptions = {
  dsn: config.SENTRY_DSN,
  release: '_20240411145931-e9bd195',
}

ReactDOM.render(
  <ConnectedApp render={() => <App />} sentryConfig={sentryConfig} />,
  document.getElementById('root')
)
